import { styled } from "@mui/material";

export const StyledSingleValuesContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 1.571rem;
  flex: 1;
  min-width: 0;

  .MuiInputAdornment-root:not(:first-of-type) {
    margin-left: 0;
    margin-right: ${(props) => props.theme.wsc.spacing[0]};
  }
`;

export const StyledValue = styled("div")`
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  align-items: center;
`;

export const StyledButtons = styled("div")`
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
`;
